module.exports = __webpack_public_path__ + "img/cn.ff61a930.png";